import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Alert, Button, Card, Modal, Spinner, Table } from 'react-bootstrap';
import { fetchClientPortalInvoicePayments } from '../api/clientPortalApi';
import { formatCurrency, formatDate } from '../utils/formatters';

export function InvoicePaymentDetails({ invoiceName, inline = false }) {
  const [show, setShow] = useState(false);
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['client-portal-invoice-payments', invoiceName],
    queryFn: () => fetchClientPortalInvoicePayments(invoiceName),
    enabled: inline || show,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    retry: false,
  });
  const content = <>
        {isLoading ? <Spinner animation="border" role="status"><span className="visually-hidden">Loading payments</span></Spinner>
          : isError ? <Alert variant="danger">Unable to load payment details. <Button variant="link" size="sm" onClick={() => refetch()}>Try again</Button></Alert>
          : !data?.results?.length ? <p className="mb-0">No payment details available.</p>
          : <Table size="sm">
            <thead><tr><th>Amount</th><th>Date</th><th>Payment type</th></tr></thead>
            <tbody>{data.results.map((payment, index) => <tr key={index}>
              <td>{typeof payment.amount === 'number' ? formatCurrency({ amount: payment.amount, currency: payment.currency }) : '–'}</td>
              <td>{formatDate(payment.date)}</td><td>{payment.origin || '–'}</td>
            </tr>)}</tbody>
          </Table>}
  </>;
  if (inline) return (
    <Card className="mb-4">
      <Card.Header as="h5">Payment details</Card.Header>
      <Card.Body>{content}</Card.Body>
    </Card>
  );
  return <>
    <Button variant="link" size="sm" className="p-0" onClick={() => setShow(true)}>Payment details</Button>
    <Modal show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton><Modal.Title>Payments · {invoiceName}</Modal.Title></Modal.Header>
      <Modal.Body>{content}</Modal.Body>
    </Modal>
  </>;
}
